import {
  SystemNamesEnum,
  WorkflowExternalStepDefDtoModel,
  WorkflowUiDefinitionModel
} from "@well/iriro-frontend-libs/workflows/domain";
import {DefinitionsNameEnum} from "./DefinitionsName.enum";

class PaymentDefinition implements WorkflowUiDefinitionModel {
  configuredBy= null;
  configuredForOwner= false;
  defaultLabel= null
  name= DefinitionsNameEnum.PAYMENTS
  systemName= SystemNamesEnum.DELIVERY
  definitionFile= 'PaymentDefinition'
  uiSteps = {
    displayResendMail: WorkflowExternalStepDefDtoModel.createWorkflowStepVoModel(DefinitionsNameEnum.PAYMENTS + "_1", SystemNamesEnum.ANGULAR_FRONTEND),
  }
  uuid= null
  valid= null
  validFrom= null
  validTo= null
}

export const paymentDefinition = new PaymentDefinition();

